import React from 'react';

import cx from 'classnames';

import generateRandomString from 'utils/generateRandomString';

import s from './index.module.css';

const Links = (props) => {
  const { links = [] } = props;

  const handleClick = (itemId) => {
    const currentLink = document.getElementById(itemId);
    if (currentLink) currentLink.scrollIntoView({ inline: 'center' });
  };

  return (
    <div className={s.bottom}>
      {links.map((link, i) => {
        const itemId = generateRandomString(5);

        return (
          <div
            key={i}
            id={itemId}
            onClick={() => handleClick(itemId)}
            className={cx(s.link, { [s.disabled]: link.props.disabled })}
            children={link}
          />
        );
      })}
    </div>
  );
};

export default Links;
